import React from 'react';
import CmsPublicPage from './CmsPublicPage';

const TermsPage = () => (
    <CmsPublicPage pageKey="terms" breadcrumbLabel="Terms & Conditions" />
);

export default TermsPage;
